import { call, takeLatest, select, put, take } from 'redux-saga/effects';
import { makeBackendApi } from 'services/BackendApi';
import { offerSelector } from '../subdomains/offer/selectors';
import { uiStateSelector } from '../subdomains/uiState/selectors';
import { mergedOrderedOffersListSelector } from '../crossdomainSelectors';
import { IOfferUI } from '../../../../services/BackendApi/types/OfferResponse';
import {
  POST_OFFER_REQUEST,
  POST_OFFERS_ORDER_SUCCESS,
  POST_OFFERS_ORDER_FAILURE,
  postOfferSuccessAction,
  postOfferFailureAction,
  postOffersOrderRequestAction,
  PostOfferRequestAction,
} from '../actions';
import { getBootstrapHotelsSelector } from 'store/modules/bootstrap/selectors';
import { IBootstrapHotel } from '../../bootstrap/model';
import { transformUiOfferToApiOffer, toOrderedOffer, transformApiOfferToUiOffer } from '../utils';
import { IOfferUiState, OrderedOffer } from '../model';
import { selectedTaSelector } from '../../agents';

export function* postOfferRequestSaga(action: PostOfferRequestAction) {
  try {
    const uiOffer: IOfferUI = yield select(offerSelector);
    const uiState: IOfferUiState = yield select(uiStateSelector);
    const orderedOffers: OrderedOffer[] = yield select(mergedOrderedOffersListSelector);

    const hotels: IBootstrapHotel[] = yield select(getBootstrapHotelsSelector);
    const selectedTa = yield select(selectedTaSelector);
    const backendApi = makeBackendApi(selectedTa?.uuid);

    const { response, error } = yield call(backendApi.postOffer, transformUiOfferToApiOffer(uiOffer, uiState));
    if (error) {
      yield put(postOfferFailureAction('Post error'));
    }

    if (response) {
      const offerWithHotel = {
        ...response.data.data,
        hotel: {
          name: hotels.find(h => h.uuid === uiOffer.hotelUuid)?.name,
          countryCode: hotels.find(h => h.uuid === uiOffer.hotelUuid)?.countryCode,
        },
      };

      yield put(postOfferSuccessAction(transformApiOfferToUiOffer(offerWithHotel)));

      const updatedOrderedOffers = orderedOffers.map(item => (item.selected ? toOrderedOffer(offerWithHotel) : item));

      yield put(postOffersOrderRequestAction(updatedOrderedOffers));
      yield take([POST_OFFERS_ORDER_SUCCESS, POST_OFFERS_ORDER_FAILURE]);

      yield call(action.history.replace, `/offers/${response.data.data.uuid}/edit`);
    } else {
      yield put(postOfferFailureAction(error.response.data.errors));
    }
  } catch (e) {
    // TODO: Need an unexpected error handler
    yield put(postOfferFailureAction('Post error'));
  }
}

export function* watchPostOfferRequest() {
  yield takeLatest(POST_OFFER_REQUEST, postOfferRequestSaga);
}
